import { render } from "./fundamental.vue?vue&type=template&id=275793d8&scoped=true"
import script from "./fundamental.vue?vue&type=script&lang=js"
export * from "./fundamental.vue?vue&type=script&lang=js"

import "./fundamental.vue?vue&type=style&index=0&id=275793d8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275793d8"]])

export default __exports__